import type { AssistantEvent } from '../../../supabase/functions/assistente/sse.ts';

// Lê o text/event-stream da função assistente; um evento por linha "data: <json>".
export async function readSse(body: ReadableStream<Uint8Array>, onEvent: (e: AssistantEvent) => void): Promise<void> {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let sep: number;
    while ((sep = buffer.indexOf('\n\n')) !== -1) {
      const block = buffer.slice(0, sep);
      buffer = buffer.slice(sep + 2);
      for (const line of block.split('\n')) {
        if (line.startsWith('data: ')) onEvent(JSON.parse(line.slice(6)) as AssistantEvent);
      }
    }
  }
}
